import { Link } from "react-router-dom";
import { Lightbulb } from "lucide-react";

/**
 * 画面内に「💡 こんなことできる」ヒントを差し込むコンポーネント。
 * クリックするとヘルプの該当 Tip にスクロール遷移する。
 *
 * @param {string} text - 表示テキスト
 * @param {string} anchor - /manager/help#anchor の anchor 部分（例: "tip-status"）
 * @param {boolean} subtle - true なら背景なしの控えめ表示
 */
export default function HiddenTipHint({ text, anchor, subtle = false, testId }) {
  return (
    <Link
      to={`/manager/help#${anchor}`}
      data-testid={testId || `hint-${anchor}`}
      className={
        subtle
          ? "inline-flex items-center gap-1 text-xs text-amber-700 hover:text-amber-800 hover:underline transition-colors"
          : "inline-flex items-center gap-1.5 text-xs text-amber-800 bg-amber-50 hover:bg-amber-100 border border-amber-200 rounded-full px-2.5 py-1 transition-colors"
      }
    >
      <Lightbulb className="w-3.5 h-3.5 text-amber-500 shrink-0" />
      <span className="leading-tight">{text}</span>
    </Link>
  );
}
